import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1201Model } from '../kymw1201.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import {
  PublishPlanGoodsCategory,
  PublishPlanGoodsCategoryListInfo,
} from '../vo/publish-plan-goods-category-list-info.model';
import { PublishPlanGoodsEditableCategory } from '../vo/publish-plan-goods-category-list-editable-info.model';

// レスポンス構造
export type GetPublishPlanGoodsCategoryListInfoResponse = {
  ConfirmFlg: string;
  UseNumPeople: string;
  TotalLineNum: string;
  MediumSurfaceLineNum: string;
  LargeComaNum: string;
  PlanResult: string;
  Supply: string;
  Gp: string;
  PublishPlanGoodsCategoryList: {
    OrderCode: string;
    CatalogId: string;
    ClassName: string;
    MiddleClassName: string;
    SmallClassName: string;
    GoodsName: string;
    GoodsStandardName: string;
    PCode: string;
    ItemCode: string;
    JanCode: string;
    LargeClassName: string;
    PayeeClientKanji: string;
    OrderClientKanji: string;
    ApplyTermEnd: string;
    SpecialFeature: string;
    Folio: string;
    Edlp: string;
    RememberGoods: string;
    OrderReceptionStartCatalog: string;
    OrderReceptionEndCatalog: string;
    CoopEnabledFlg142: string;
    CoopEnabledFlg163: string;
    CoopEnabledFlg185: string;
    CoopEnabledFlg240: string;
    CoopEnabledFlg210: string;
    CoopEnabledFlg302: string;
    CoopEnabledFlg515: string;
    CoopEnabledFlg451: string;
    GoodsMemo: string;
    BuyerComment: string;
    CoopFlg142: string;
    CoopFlg163: string;
    CoopFlg185: string;
    CoopFlg240: string;
    CoopFlg210: string;
    CoopFlg302: string;
    CoopFlg515: string;
    CoopFlg451: string;
    PricePattern: string;
    PricePromotion: string;
    BargainMarkFlg: string;
    KomaPromotion: string;
    PromotionMark: string;
    AppearDiv: string;
    OrderNumQuotaCode: string;
    OrderNumQuotaName: string;
    MediumWPublishFlg: string;
    CrossCode: string;
    PCodeOfCross: string;
    CrossDecisionFlg: string;
    WCrossFlg: string;
    ThisTimeSupplyPrice: string;
    ThisTimeCostPrice: string;
    SupplyPriceStandard: string;
    SupplyPriceSpecial1: string;
    SupplyPriceSpecial2: string;
    CostPriceStandard: string;
    CostPriceSpecial1: string;
    CostPriceSpecial2: string;
    BundlePrice: string;
    PlanNumAiPrediction: string;
    PlanNum: string;
    WCarryingFlg: string;
    MainCoopCode: string;
  }[];
};

/**
 * 企画回別商品一覧情報取得サービス
 * @export GetPublishPlanGoodsCategoryListInfo
 * @class GetPublishPlanGoodsCategoryListInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPublishPlanGoodsCategoryListInfo extends PlessJsonResponderSub<GetPublishPlanGoodsCategoryListInfoResponse> {
  private model: KYMW1201Model;
  private isUpdateCrossAfter: boolean;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishPlanGoodsCategoryListInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CatalogInfo: {
          condition: {
            OrderCode: this.model.orderCode,
            MediumType: this.model.mediumType,
            BuyerCode: this.model.buyerCode,
            SupplierCode: this.model.supplierCode,
          }
        }
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPublishPlanGoodsCategoryListInfo
   */
  execute(model: KYMW1201Model, isUpdateCrossAfter: boolean, f: () => void = null): void {
    this.model = model;
    this.isUpdateCrossAfter = isUpdateCrossAfter;
    this.calbak = f;
    this.send('getPublishPlanGoodsCategoryListInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogInfo
   */
  success(data: GetPublishPlanGoodsCategoryListInfoResponse) {
    if (!this.isUpdateCrossAfter) {
      this.model.publishPlanGoodsCategoryListInfo = new PublishPlanGoodsCategoryListInfo(
        data.ConfirmFlg,
        data.UseNumPeople,
        data.TotalLineNum,
        data.MediumSurfaceLineNum,
        data.LargeComaNum,
        data.PlanResult,
        data.Supply,
        data.Gp,
        Number(data.Supply) !== 0 ? String((Number(data.Gp) / Number(data.Supply)) * 100) : '0',
        data.PublishPlanGoodsCategoryList.map(_ => {
          const piValue = PublishPlanGoodsCategory.getPIValue(_.PlanNum, data.UseNumPeople, _.PlanNumAiPrediction);
          const supplyBudget = PublishPlanGoodsCategory.getSupplyBudget(_.ThisTimeSupplyPrice, _.PlanNum, _.PlanNumAiPrediction);
          const gpValue = PublishPlanGoodsCategory.getGPValue(supplyBudget, _.PlanNum, _.ThisTimeCostPrice, _.BundlePrice, _.PlanNumAiPrediction);
          const gprValue = PublishPlanGoodsCategory.getGPRValue(gpValue, supplyBudget);
          return new PublishPlanGoodsCategory(
            _.OrderCode,
            _.CatalogId,
            _.ClassName,
            _.MiddleClassName,
            _.SmallClassName,
            _.GoodsName,
            _.GoodsStandardName,
            _.PCode,
            _.ItemCode,
            _.JanCode,
            _.LargeClassName,
            _.PayeeClientKanji,
            _.OrderClientKanji,
            _.ApplyTermEnd,
            _.SpecialFeature,
            _.Folio,
            _.Edlp,
            _.RememberGoods,
            _.OrderReceptionStartCatalog,
            _.OrderReceptionEndCatalog,
            _.GoodsMemo,
            _.BuyerComment,
            _.CoopFlg142 === '1' ? true: false,
            _.CoopFlg163 === '1' ? true: false,
            _.CoopFlg185 === '1' ? true: false,
            _.CoopFlg240 === '1' ? true: false,
            _.CoopFlg210 === '1' ? true: false,
            _.CoopFlg302 === '1' ? true: false,
            _.CoopFlg515 === '1' ? true: false,
            _.CoopFlg451 === '1' ? true: false,
            _.CoopEnabledFlg142 === '1' ? true: false,
            _.CoopEnabledFlg163 === '1' ? true: false,
            _.CoopEnabledFlg185 === '1' ? true: false,
            _.CoopEnabledFlg240 === '1' ? true: false,
            _.CoopEnabledFlg210 === '1' ? true: false,
            _.CoopEnabledFlg302 === '1' ? true: false,
            _.CoopEnabledFlg515 === '1' ? true: false,
            _.CoopEnabledFlg451 === '1' ? true: false,
            _.PricePattern,
            _.PricePromotion,
            _.BargainMarkFlg === '1' ? true: false,
            _.KomaPromotion,
            _.PromotionMark,
            _.AppearDiv,
            _.OrderNumQuotaCode,
            _.OrderNumQuotaName,
            _.MediumWPublishFlg === '1' ? true: false,
            _.CrossCode,
            _.PCodeOfCross,
            _.CrossDecisionFlg === '1' ? true: false,
            _.WCrossFlg === '1' ? true: false,
            _.ThisTimeSupplyPrice,
            _.ThisTimeCostPrice,
            _.SupplyPriceStandard,
            _.SupplyPriceSpecial1,
            _.SupplyPriceSpecial2,
            _.CostPriceStandard,
            _.CostPriceSpecial1,
            _.CostPriceSpecial2,
            _.BundlePrice,
            _.PlanNumAiPrediction,
            _.PlanNum,
            _.WCarryingFlg === '1' ? true: false,
            _.MainCoopCode,
            piValue,
            supplyBudget,
            gpValue,
            gprValue,
          )
        })
      );
      this.model.publishPlanGoodsCategoryInfo = this.model.publishPlanGoodsCategoryListInfo.publishPlanGoodsCategoryList;
    } else {
      // クロス候補確認、クロス設定登録、クロス設定解除後の一覧再取得時は、
      // すでに一覧表示済みの各行の CrossCode, PCodeOfCross, WCrossFlg のみ更新する
      // 丸ごと更新してしまうとクロス以外の保存前の情報が失われてしまうこと、
      // CrossCode の値はクロス更新APIで取得できず本APIでしか取得できないため
      for (const e of data.PublishPlanGoodsCategoryList) {
        for (const ee of this.model.publishPlanGoodsCategoryInfo) {
          if (e.PCode === ee.pcode) {
            if (e.CrossCode !== ee.crossCode) {
              if (e.CrossCode) {
                // クロスコードありへの変更時はクロス設定確定のチェックをつける
                ee.crossDecisionFlg = true;
              } else {
                // クロスコードなしへの変更時はクロス設定確定のチェックを外す
                ee.crossDecisionFlg = false;
              }
            }
            ee.crossCode = e.CrossCode;
            ee.pCodeOfCross = e.PCodeOfCross;
            ee.wCrossFlg = e.WCrossFlg === '1' ? true: false;
          }
        }
      }
    }

    // 変更前のデータ格納
    this.model.publishPlanGoodsCategoryInfoOrigin = data.PublishPlanGoodsCategoryList.map(_ => 
      new PublishPlanGoodsEditableCategory(_));

    if (this.calbak) this.calbak();
  }
}
